import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminCreateChart = () => {
  const queryClient = useQueryClient();

  return apiClient.chart.createChart.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-charts-list'] });
      toast.success('Chart created successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error creating chart!');
    },
  });
};
